import { styled, media } from '@thesisedu/web/dist'
import React from 'react'

import { Content } from './Article'

export function StepImage({ node: { image, mobileDisplay, content } }) {
  return (
    <Container className={`step-image ${mobileDisplay ? '' : 'web'}`}>
      <div className={'step-image-heading'}>
        <Content content={image} />
      </div>
      <div className={'step-image-body'}>
        <Content content={content} />
      </div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  margin: ${props => props.theme['@size-m']} 0;
  & + .step-image {
    padding-top: ${props => props.theme['@size-m']};
    border-top: solid 2px ${props => props.theme['@border-color-split']};
  }
  ${media.lg} {
    flex-wrap: nowrap;
  }
  > .step-image-heading {
    display: block;
    img {
      max-width: 100% !important;
    }
    &,
    figure {
      min-width: 200px;
      max-width: 300px;
      margin: 0 auto;
    }
    ${media.lg} {
      margin: 0;
    }
  }
  &.web > .step-image-heading {
    &,
    figure,
    img {
      min-width: 300px;
      max-width: 500px;
    }
  }
  > .step-image-body {
    margin: ${props => props.theme['@size-s']} 0 0 0;
    text-align: center;
    max-width: max-content;
    overflow-x: scroll;
    flex-grow: 1;
    code {
      display: inline-block;
      overflow-x: scroll;
      max-width: 100%;
    }
    ${media.lg} {
      margin: ${props => props.theme['@size-s']} 0 0 ${props => props.theme['@size-m']};
      text-align: left;
      > :first-child {
        margin-top: 0;
      }
    }
  }
`
